export const COOPERATION_LEVEL_BANDS = [
  { band: "A", hint: "טוב", values: [1, 2, 3] },
  { band: "B", hint: "בינוני", values: [4, 5, 6] },
  { band: "C", hint: "חלש", values: [7, 8, 9] },
] as const;

export const COOPERATION_LEVEL_OPTIONS = COOPERATION_LEVEL_BANDS.flatMap((row) =>
  row.values.map((value) => ({
    value,
    band: row.band,
    hint: row.hint,
    label: `${row.band}${value}`,
  })),
);

/** 1 is best, 9 is worst. Missing ranks after 9. */
export function cooperationSortValue(
  level: number | null | undefined,
): number {
  return level == null || level < 1 ? 10 : level;
}

export function cooperationLevelCode(
  level: number | null | undefined,
): string {
  if (level == null) return "";
  const option = COOPERATION_LEVEL_OPTIONS.find((item) => item.value === level);
  return option?.label ?? String(level);
}

export function cooperationLevelShortLabel(
  level: number | null | undefined,
): string {
  return cooperationLevelCode(level);
}

export function cooperationLevelChipColor(
  level: number | null | undefined,
): "default" | "secondary" | "primary" {
  if (level == null || level > 6) return "default";
  if (level >= 4) return "secondary";
  return "primary";
}
